module.exports = "/packs/images/products/starter-kit@3x-c2c8cc5e2a8a5a2e452f81af8438a3a7.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/starter-kit@3x.png
// module id = 968
// module chunks = 0 1